import { Flex, Stack, FlexProps, StackProps } from '@mantine/core';
import styled from 'styled-components';

/** Full-bleed light-grey header banner (icon + title + subtitle). */
export const HeaderPanel = styled(Flex)<FlexProps>`
	flex-direction: column;
	align-items: center;
	gap: 0.25rem;
	padding: 2rem 1.5rem;
	background-color: ${({ theme }) => theme.v3.colors.gray[0]};
	text-align: center;
`;

/** Detail body (signer/method/session) — padded away from the card edges. */
export const Body = styled(Stack)<StackProps>`
	padding: 1.5rem;
`;

export const SessionList = styled.ul`
	margin: 0;
	padding-left: 1.25rem;
	list-style: disc outside;

	li {
		color: ${({ theme }) => theme.v3.colors.dark[2]};
		font-size: 0.875rem;
		line-height: 1.3;

		&::marker {
			color: ${({ theme }) => theme.v3.colors.dark[2]};
		}

		&:not(:last-child) {
			margin-bottom: 0.375rem;
		}
	}
`;
